import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Injectable()
export class NotificationService {
  constructor(private readonly notification: NzNotificationService) {}
  notify(title: string, message: string) {
    this.notification.blank(title, message);
  }
}
